<ng-container *ngIf="mode == 'ReadOnly'; then read; else edit"></ng-container>
<ng-template #read>
    <span>{{control?.value?.name ? control?.value?.name : 'Not Set'}}</span>
</ng-template>
<ng-template #edit>

    <ng-select [items]="data" bindLabel="name" [placeholder]="placeholder" [compareWith]="compareFn" [searchFn]="searchFn" [multiple]="multiple" [searchable]="true" [formControl]="control">
        <ng-template ng-option-tmp let-item="item" let-index="index">{{item?.name ? item?.name : 'Not Set'}}</ng-template>

        <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <div class="view-template">
                <div class="mr-5">{{item?.name }}</div>
                <div *ngIf="multiple === true" class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</div>
            </div>
        </ng-template>
    </ng-select>

</ng-template>


<ng-template #emptyField>
    <span class="empty-field">{{ emptyText }}</span>
</ng-template>